<div class="sidebar">

  <!-- =========================
       TOP QUICK LINKS
  ========================== -->

  <div class="quick-links">

    <a
      class="quick-item"
      *ngFor="let link of quickLinks; trackBy: trackByLink"
      [href]="linkHref(link)"
      (mouseenter)="prefetch(link)"
      (touchstart)="prefetch(link)"
      (click)="go(link, $event)"
    >
      <span
        class="quick-icon"
        [innerHTML]="getIcon(link.iconKey)"
      ></span>

      <span>
        {{ linkLabel(link) }}
      </span>
    </a>

  </div>


  <!-- DIVIDER -->

  <div class="divider"></div>


  <!-- =========================
       MAIN CATEGORIES
  ========================== -->

  <ng-container
    *ngFor="let c of categories"
  >

    <!-- EMPTY CATEGORY HIDE -->

    <ng-container
      *ngIf="c?.name && c.name.trim()"
    >

      <!-- MAIN -->

      <div
        class="item"
        [class.active]="
          selectedId === c.id
        "
        (click)="
          handleMain(c, $event)
        "
      >

        <span class="item-name" [attr.title]="categoryName(c)">
          {{ categoryName(c) }}
        </span>


        <span
          *ngIf="c.children?.length"
          class="arrow"
          [class.open]="
            expandedMain === c.id
          "
        >
          ›
        </span>

      </div>


      <!-- =========================
           SUB CATEGORIES
      ========================== -->

      <div
        *ngIf="
          expandedMain === c.id &&
          c.children?.length
        "
        class="sub"
      >

        <ng-container
          *ngFor="let s of c.children"
        >

          <!-- EMPTY SUB HIDE -->

          <ng-container
            *ngIf="s?.name && s.name.trim()"
          >

            <div
              class="sub-item"
              [class.active]="
                selectedId === s.id
              "
              (click)="
                handleSub(
                  s,
                  c,
                  $event
                )
              "
            >

              <span class="sub-dot"></span>


              <span class="item-name" [attr.title]="categoryName(s)">
                {{ categoryName(s) }}
              </span>


              <span
                *ngIf="s.children?.length"
                class="arrow"
                [class.open]="
                  expandedSub === s.id
                "
              >
                ›
              </span>

            </div>


            <!-- =========================
                 CHILD CATEGORIES
            ========================== -->

            <div
              *ngIf="
                expandedSub === s.id &&
                s.children?.length
              "
              class="child"
            >

              <ng-container
                *ngFor="let ch of s.children"
              >

                <!-- EMPTY CHILD HIDE -->

                <div
                  *ngIf="
                    ch?.name &&
                    ch.name.trim()
                  "
                  class="child-item"
                  [class.active]="
                    selectedId === ch.id
                  "
                  (click)="
                    handleChild(
                      ch,
                      s,
                      c,
                      $event
                    )
                  "
                >

                  <span class="child-dot"></span>


                  <span class="item-name" [attr.title]="categoryName(ch)">
                    {{ categoryName(ch) }}
                  </span>

                </div>

              </ng-container>

            </div>

          </ng-container>

        </ng-container>

      </div>

    </ng-container>

  </ng-container>


  <!-- DIVIDER -->

  <div class="divider"></div>


  <!-- =========================
       EXTRA LINKS
  ========================== -->

  <div class="extra">

    <a
      class="link"
      *ngFor="let link of extraLinks; trackBy: trackByLink"
      [href]="linkHref(link)"
      (click)="go(link, $event)"
    >
      <span
        class="link-icon"
        [innerHTML]="getIcon(link.iconKey)"
      ></span>

      <span>
        {{ linkLabel(link) }}
      </span>
    </a>

  </div>

</div>